import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="preview-poll"
export default class extends Controller {
  static values = {
    url: String,
    intervalMs: { type: Number, default: 1500 },
    maxTries: { type: Number, default: 120 }
  }

  connect() {
    this._tries = 0
    this._timer = null
    this.start()
  }

  disconnect() {
    this.stop()
  }

  start() {
    if (!this.hasUrlValue) return
    if (this._timer) return

    this._timer = window.setInterval(() => this.tick(), this.intervalMsValue)
    this.tick()
  }

  stop() {
    if (this._timer) window.clearInterval(this._timer)
    this._timer = null
  }

  currentStatus() {
    const el = this.element.querySelector("[data-paper-preview-status]")
    return el ? el.getAttribute("data-paper-preview-status") : null
  }

  async tick() {
    const status = this.currentStatus()
    if (status === "completed" || status === "failed") {
      this.stop()
      return
    }

    this._tries += 1
    if (this._tries > this.maxTriesValue) {
      this.stop()
      return
    }

    try {
      const resp = await fetch(this.urlValue, {
        headers: { "Accept": "text/html" },
        credentials: "same-origin"
      })
      if (!resp.ok) return

      this.element.innerHTML = await resp.text()
      const nextStatus = this.currentStatus()
      if (nextStatus === "completed" || nextStatus === "failed") this.stop()
    } catch (_e) {
      // Ignore transient network issues; try again next tick.
    }
  }
}

